/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ progress: NonNullable<unknown> }} Ocr_Extracting_InvertedInputs */

const en_ocr_extracting_inverted = /** @type {(inputs: Ocr_Extracting_InvertedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Extracting inverted frames... ${i?.progress}%`)
};

const fr_ocr_extracting_inverted = /** @type {(inputs: Ocr_Extracting_InvertedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Extraction des images inversées... ${i?.progress}%`)
};

const de_ocr_extracting_inverted = /** @type {(inputs: Ocr_Extracting_InvertedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Extrahieren invertierter Frames... ${i?.progress}%`)
};

const it_ocr_extracting_inverted = /** @type {(inputs: Ocr_Extracting_InvertedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Estrazione dei fotogrammi invertiti... ${i?.progress}%`)
};

const ru_ocr_extracting_inverted = /** @type {(inputs: Ocr_Extracting_InvertedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Извлечение инвертированных кадров... ${i?.progress}%`)
};

const es_ocr_extracting_inverted = /** @type {(inputs: Ocr_Extracting_InvertedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Extrayendo fotogramas invertidos... ${i?.progress}%`)
};

const zh_cn2_ocr_extracting_inverted = /** @type {(inputs: Ocr_Extracting_InvertedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在提取反转帧... ${i?.progress}%`)
};

const ja_ocr_extracting_inverted = /** @type {(inputs: Ocr_Extracting_InvertedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`反転フレームを抽出中... ${i?.progress}%`)
};

const hi_ocr_extracting_inverted = /** @type {(inputs: Ocr_Extracting_InvertedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`उल्टे फ्रेम निकाले जा रहे हैं... ${i?.progress}%`)
};

const pt_pt2_ocr_extracting_inverted = /** @type {(inputs: Ocr_Extracting_InvertedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Extraindo quadros invertidos... ${i?.progress}%`)
};

/**
* | output |
* | --- |
* | "Extracting inverted frames... {progress}%" |
*
* @param {Ocr_Extracting_InvertedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_extracting_inverted = /** @type {((inputs: Ocr_Extracting_InvertedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Extracting_InvertedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_extracting_inverted(inputs)
	if (locale === "de") return de_ocr_extracting_inverted(inputs)
	if (locale === "it") return it_ocr_extracting_inverted(inputs)
	if (locale === "ru") return ru_ocr_extracting_inverted(inputs)
	if (locale === "es") return es_ocr_extracting_inverted(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_extracting_inverted(inputs)
	if (locale === "ja") return ja_ocr_extracting_inverted(inputs)
	if (locale === "hi") return hi_ocr_extracting_inverted(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_extracting_inverted(inputs)
	return en_ocr_extracting_inverted(inputs)
});